import ReactMounter from 'lib/ReactMounter';
import OurMissionPage from 'pages/OurMissionPage/OurMissionPage';

ReactMounter.registerComponentToMountOnLoad('OurMissionPage', OurMissionPage);
